export enum ViewType {
  List,
  Grid,
  Film,
}
